/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseModule } from '../../models/api-response-module';
import { Module } from '../../models/module';

export interface UpdateModule$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  ref: string;
      body: Module
}

export function updateModule(http: HttpClient, rootUrl: string, params: UpdateModule$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseModule>> {
  const rb = new RequestBuilder(rootUrl, updateModule.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('ref', params.ref, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseModule>;
    })
  );
}

updateModule.PATH = '/v1/api/admin-ui/module/{ref}';
